/* eslint-disable @mizdra/layout-shift/require-size-attributes */

import React from 'react';
import classNames from 'classnames/bind';
import propTypes from 'prop-types';
import * as styles from './info-pod-container.scss';

const cx = classNames.bind(styles);
export const InfoPodsContainer = ({
  leftPodTitle,
  rightPodTitle,
  leftPodDetails,
  rightPodDetails
}) => {

  const iconUrl = 'https://assets.homedepot-static.com/images/v1/check.svg';
  return (
    <div className={cx('info-pod-container')}>
      <div className={cx('info-pod-container__details-wrapper')}>
        <b className={cx('info-pod-container__heading')}>
          <img
            src={iconUrl}
            alt="check mark"
            aria-hidden="true"
            className={cx('info-pod-container__icon')}
          />
          {leftPodTitle}
        </b>
        <div className={cx('info-pod-container__detail')}>
          {leftPodDetails}
        </div>
      </div>
      <div className={cx('info-pod-container__details-wrapper', 'info-pod-container__details-wrapper--rightmost')}>
        <div className={cx('info-pod-container__heading')}>
          <img
            src={iconUrl}
            alt=""
            aria-hidden="true"
            className={cx('info-pod-container__icon')}
          />
          { rightPodTitle }
        </div>
        <div className={cx('info-pod-container__detail')}>
          {rightPodDetails }
        </div>
      </div>
    </div>
  );
};

InfoPodsContainer.propTypes = {
  leftPodTitle: propTypes.string.isRequired,
  rightPodTitle: propTypes.string.isRequired,
  leftPodDetails: propTypes.string.isRequired,
  rightPodDetails: propTypes.string.isRequired
};
